import React, { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useRouteMatch } from "react-router-dom";

import {
  Box,
  ClickAwayListener,
  Grow,
  IconButton,
  Paper,
  Popper,
  Typography,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import LocationToggler from "../../LocationToggler";
import { CustomTab, CustomTabs } from "../../Tabs/CustomTabs";
import Avatar from "../Avatar";

import actions from "../../../Stores/Auth/actions";

import { validateBoolItem } from "../../../utils/helpers";
import { useStyles } from "./style";

const logoutAction = actions.logout;

const UserHeader = ({
  hasTab,
  paths,
  location,
  showProfileTabs,
  profileTabs,
  profileLocation,
  showLocationToggle,
  title,
  onLocationChange,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.AuthReducer.user);
  const { company_setting: settings } = userInfo ?? {};

  const { menuOpen } = useSelector((state) => state.AuthReducer);
  const history = useHistory();
  const isTimeSheet = useRouteMatch("/d/timesheet/list")?.isExact;
  const isRoster = useRouteMatch("/d/rota/week")?.isExact;
  const isRosterAlloc = useRouteMatch("/d/rota/month")?.isExact;
  const isPayroll = useRouteMatch(
    "/d/timesheet/payroll/:from_date/:to_date"
  )?.isExact;

  let canViewHamburger = isTimeSheet || isPayroll || isRoster || isRosterAlloc;

  const [open, setOpen] = React.useState(false);
  const [greeting, setGreeting] = React.useState("");

  const date = new Date();
  let hours = date.getHours();

  useEffect(() => {
    let text = "Good Morning";
    if (hours) {
      if (hours < 12) {
        text = "Good Morning";
      } else if (hours < 17) {
        text = "Good Afternoon";
      } else {
        text = "Good Evening";
      }
    }
    setGreeting(text);
  }, [hours]);

  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  return (
    <>
      <Box
        className={classes.wrap}
        style={{ padding: hasTab ? `0px 10px` : `0px` }}
      >
        <Box className={classes.wrapContent}>
          <Box className={classes.userRoutes}>
            {canViewHamburger && (
              <Box>
                <IconButton
                  onClick={() => dispatch(actions.toggleMenu(!menuOpen))}
                >
                  <MenuIcon />
                </IconButton>
              </Box>
            )}
            {showProfileTabs && showProfileTabs === true && (
              <Box>
                <CustomTabs
                  value={profileLocation?.pathname}
                  onChange={() => {}}
                  textColor="primary"
                  variant="scrollable"
                >
                  {profileTabs.map((path, index) => {
                    let canRender = false;
                    let component = <></>;

                    if (path?.requires_check) {
                      canRender = validateBoolItem(
                        path,
                        userInfo,
                        userInfo?.accounting_type
                      );
                    } else {
                      canRender = true;
                    }

                    if (canRender) {
                      component = (
                        <CustomTab
                          component={Link}
                          to={
                            profileTabs[index].path_to_go
                              ? profileTabs[index].path_to_go
                              : profileTabs[index].path
                          }
                          value={
                            profileTabs[index].path_to_match
                              ? profileTabs[index].path_to_match
                              : profileTabs[index].path
                          }
                          label={path.title}
                        />
                      );
                    }

                    return component;
                  })}
                </CustomTabs>
              </Box>
            )}
            {hasTab && hasTab === true && (
              <Box>
                <CustomTabs
                  value={location?.pathname}
                  onChange={() => {}}
                  textColor="primary"
                >
                  {paths.map((path, index) => (
                    <CustomTab
                      component={Link}
                      to={paths[index].path}
                      value={paths[index].path}
                      label={path.title}
                    />
                  ))}
                </CustomTabs>
              </Box>
            )}
          </Box>
          <Box className={classes.userInfo}>
            {showLocationToggle && (
              <LocationToggler
                history={history}
                onLocationChange={onLocationChange}
              />
            )}
            <Box
              className={classes.userBadge}
              onClick={handleToggle}
              ref={anchorRef}
            >
              <Avatar />
            </Box>
          </Box>
        </Box>
      </Box>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-end"
        disablePortal={false}
        role={undefined}
        transition
        style={{
          zIndex: "15",
        }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper className={classes.popperContent}>
              <h4 className={classes.poperHeader}>
                {greeting},
                <span className={classes.poperSubHeader}>
                  {" "}
                  {userInfo?.id ? userInfo?.name : `~`}
                </span>
              </h4>
              <Box className={classes.userData}>
                <Typography className={classes.email}>
                  {userInfo?.id ? userInfo?.email : "~"}
                </Typography>
              </Box>
              <div className={classes.divider}></div>
              <ClickAwayListener onClickAway={handleClose}>
                <ul className={classes.list}>
                  <li
                    className={classes.listLink}
                    onClick={() => {
                      history.push("/d/myprofile");
                    }}
                  >
                    Profile
                  </li>
                  <li
                    className={classes.listLink}
                    onClick={() => {
                      history.push("/d/myprofile/notification-settings");
                    }}
                  >
                    Notification Settings
                  </li>
                  <li
                    className={classes.listLink}
                    onClick={() => {
                      dispatch(logoutAction(history));
                    }}
                  >
                    Logout
                  </li>
                </ul>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default memo(UserHeader);
